export default __webpack_public_path__ + "static/media/a10.2e026dd9.webp";